// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"success-view-m__wrapper__oGoJ8","message":"success-view-m__message__Ig1TD","tick-wrapper":"success-view-m__tick-wrapper__I9Yex"};